export const interpolateCoords = erasedCoords => {
    if (!erasedCoords) return
    const res = []
    let chunk = 10;
    let exit = 0;

    const interpolate = (startPt, endPt, percent, index, input) => {
        exit++;
        var dx = endPt[0] - startPt[0];
        var dy = endPt[1] - startPt[1]
        if (dx > 2 || dy > 2) {
            var X = parseInt(startPt[0]) + dx * percent;
            var Y = parseInt(startPt[1]) + dy * percent;
            X = X.toFixed()
            Y = Y.toFixed()
            input.splice(index + 1, 0, [X, Y])
        } else return
    }

    const isAnotherInterpolationRequired = (input) => {
        let res = false;
        for (let i = 0; i < input.length - 1; i++) {
            if (Math.abs(input[i][0] - input[i + 1][0]) > 2 || Math.abs(input[i][1] - input[i + 1][1]) > 2) {
                res = true;
            }
        }
        return res;
    }

    const loop = (data) => {
        let input = data;
        for (let i = 0; i < input.length - 1; i++) {
            interpolate(input[i], input[i + 1], 0.5, i, input)
        }
        if (isAnotherInterpolationRequired(input) && exit < 1000) {
            loop(input)
        }
    }

    for (let i = 0; i < erasedCoords.length; i += chunk) {
        let input = erasedCoords.slice(i, i + chunk);
        loop(input)
        res.push(...input)
    }

    return res;
}

export const interpolateSquareCoords = coords => {
    let res = []

    if (coords.length === 2 && coords[0].length === 2 && coords[1].length === 2) {
        const x1 = coords[0][0]
        const y1 = coords[0][1]
        const x2 = coords[1][0]
        const y2 = coords[1][1]

        res = res.concat(interpolateCoords([[x1, y1], [x2, y1]]))
        res = res.concat(interpolateCoords([[x2, y1], [x2, y2]]))
        res = res.concat(interpolateCoords([[x1, y2], [x2, y2]]).reverse())
        res = res.concat(interpolateCoords([[x1, y1], [x1, y2]]).reverse())
    }

    return res
}

export const interpolateCircleCoords = coords => {
    let res = []

    if (coords.length === 2 && coords[0].length === 2 && coords[1].length === 2) {
        const x1 = Number(coords[0][0])
        const y1 = Number(coords[0][1])
        const x2 = Number(coords[1][0])
        const y2 = Number(coords[1][1])
        const cx = x1 + ((x2 - x1) / 2)
        const cy = y1 + ((y2 - y1) / 2)
        const rx = cx - x1
        const ry = cy - y1

        for (let angle = 0; angle <= 360; angle++) {
            const t = Math.tan(angle / 360 * Math.PI)
            res.push([
                Math.round(cx + rx * (1 - t ** 2) / (1 + t ** 2)),
                Math.round(cy + ry * 2 * t / (1 + t ** 2))
            ])
        }
    }

    return res
}

export const drawInterpolatedCoords = (context, { color, coords }, lineW) => {
    context.lineWidth = lineW
    context.strokeStyle = color
    context.stroke()
    context.beginPath()
    if (coords) {
        for (let i = 0; i < coords.length; i++) {
            context.lineTo(coords[i][0], coords[i][1])
            context.moveTo(coords[i][0], coords[i][1])
        }
    }
    context.stroke()
    context.beginPath()
}
